import { render, staticRenderFns } from "./CollaboratorTable.vue?vue&type=template&id=49f12e7b&scoped=true&"
import script from "./CollaboratorTable.vue?vue&type=script&lang=js&"
export * from "./CollaboratorTable.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorTable.vue?vue&type=style&index=0&id=49f12e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f12e7b",
  null
  
)

export default component.exports